import { Component, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_side_modal_direction_procedures_component',
    templateUrl: './c_side_modal_direction_procedures.component.html',
    styleUrls: ['../../common.scss', '../../c_side_modal.component.scss'],
    standalone: false
})
export class c_side_modal_direction_procedures_component extends BaseComponent {
  @Output() showPosition = new EventEmitter();
  @Output() hidePosition = new EventEmitter();
  
  constructor() { super(); }

  mouseEnterShowPosition(e, type) {
    e?.stopPropagation();
    this.showPosition.emit(type);
  }

  mouseLeaveHidePosition(e) {
    e?.stopPropagation();
    this.hidePosition.emit()
  }
}
